import { ListInsetControl } from '@kerfjs/ui/list-inset-control';
import { Row } from '@kerfjs/ui/row';
import { Text } from '@kerfjs/ui/text';
import { type SafeHtml } from 'kerfjs';

import type { DecisionT } from '../data/api.js';
import { CurrencyAmount } from './currency-amount.js';
import { DecisionBadge } from './decision-badge.js';
import { LINE_ITEM_SECTION_VALUES_FLEX, LineItemSectionLabel } from './line-item-section-label.js';

export function DemandLineItemDecision({
  decision,
  fallbackCurrency,
}: {
  decision: (Partial<DecisionT> & Pick<DecisionT, 'action'>) | undefined;
  fallbackCurrency: string;
}): SafeHtml {
  if (decision?.action === null || decision?.action === undefined || decision.action === '') return <></>;
  const price = decision.approvedUnitPrice ?? decision.targetPrice;
  const currency = decision.currency ?? fallbackCurrency;
  return (
    <Row className="demand-line-item-decision" vAlign="top" wrap>
      <LineItemSectionLabel label="Decision" />
      <Row flex={LINE_ITEM_SECTION_VALUES_FLEX} wrap vAlign="middle" controlInsets="rl">
        <ListInsetControl sides="tb">
          <DecisionBadge action={decision.action} />
        </ListInsetControl>
        {price != null && price !== '' ? (
          <>
            <Text tone="quiet" size="compact">
              {decision.approvedUnitPrice != null ? 'approved' : 'target'}
            </Text>
            <Text>
              <CurrencyAmount value={Number(price)} currency={currency} />
            </Text>
          </>
        ) : null}
        {/* Why a non-best quote was chosen (HS2-EKEE9S). */}
        {decision.selectionReason != null && decision.selectionReason !== '' ? (
          <>
            <Text tone="quiet" size="compact">
              not lowest:
            </Text>
            <Text>{decision.selectionReason}</Text>
          </>
        ) : null}
        {decision.note != null && decision.note !== '' ? <Text>{decision.note}</Text> : null}
      </Row>
    </Row>
  );
}
